import { SAME_TAB_TARGET } from './constants'
import type { Link } from '@wix/public-schemas'
import { addAnchorsData, addRelToLinkProps } from './linkUtils'
import type { AnchorLinkData } from './linksDataTypes'
import { PageLinkExtraData, resolvePageLinkHref } from './pageLink'
import { pickBy } from 'lodash'

export type AnchorLinkExtraData = Pick<
	PageLinkExtraData,
	| 'externalBaseUrl'
	| 'mainPageId'
	| 'disableStaticPagesUrlHierarchy'
	| 'pageIdToHierarchyRoute'
	| 'shouldEncodeUris'
	| 'pageIdToPageUriSEO'
>

export const handleAnchorLink = (linkData: AnchorLinkData, extraData: AnchorLinkExtraData): Link => {
	const { pageId, anchorName, rel } = linkData
	const href = resolvePageLinkHref(pageId, extraData)
	const baseLinkProps = {
		href,
		target: SAME_TAB_TARGET,
	} as Link
	const linkPropsWithAnchorsData = addAnchorsData(baseLinkProps, anchorName)
	const linkPropsWithRel = addRelToLinkProps(linkPropsWithAnchorsData, rel)

	return pickBy(linkPropsWithRel, (x) => x) as Link
}
